import { axiosClient } from "./axiosClient";

export const templateApi = {
  getTemplateDetails: (url) => {
    return axiosClient.get("/api/template/by-url", {
      params: { url },
    });
  },

  uploadCv: (data) => {
    const url = `/api/applicant-database/upload/cv`;
    const formData = new FormData();
    formData.append("file", data);
    return axiosClient.post(url, formData, {
      headers: {
        accept: "*/*",
        "content-type": "multipart/form-data",
      },
    });
  },

  applyJob: (data) => {
    const url = `/api/applicant-database`;

    const params = new URLSearchParams(window.location.search);
    const utmSource = params.get("utm_source");

    return axiosClient.post(url, {
      ...data,
      landingPageUrl: window.location.href,
      utmSource: utmSource || undefined,
    });
  },

  getCountry: () => {
    const url = `api/user/country-list`;
    return axiosClient.get(url);
  },

  getState: (params) => {
    const url = `/api/user/get-state/${params}`;
    return axiosClient.get(url);
  },

  getCity: (params) => {
    const url = `/api/user/get-city/${params}`;
    return axiosClient.get(url);
  },
};
